import { faMagnifyingGlass } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useTranslation } from "@onefront/react-sdk";
import Button from "@vapor/react-material/Button";
import Stack from "@vapor/react-material/Stack";
import TextField from "@vapor/react-material/TextField";
import { useState } from "react";
import { SearchProps } from "../../../newDocuments/types";
export const Search = ({ setSearchValue, width }: SearchProps) => {
  const [value, setValue] = useState("");
  const { t } = useTranslation("DOCS");
  return (
    <Stack direction="row" alignItems="end">
      <TextField
        placeholder={t("document.search.default")}
        variant="outlined"
        sx={{
          width: width,
        }}
        onChange={(e) => {
          setValue(e.target.value);
          if (e.target.value === "") {
            setValue(e.target.value);
            setSearchValue(e.target.value);
          }
        }}
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            setValue((e.target as HTMLInputElement).value);
            setSearchValue((e.target as HTMLInputElement).value);
          }
        }}
        label={t("document.search.title")}
      />
      <Button
        onClick={(e) => {
          setSearchValue(value);
        }}
        size="medium"
        sx={{
          "&.MuiButtonBase-root.MuiButton-root.MuiButton-sizeMedium": {
            borderRadius: 0,
            minWidth: 40,
            p: 1,
          },
        }}
        variant="contained"
      >
        <FontAwesomeIcon icon={faMagnifyingGlass} size="xl" />
      </Button>
    </Stack>
  );
};
